<template>
    <v-flex xs12 v-if="documents && documents.length > 0">
        <v-flex xs12>
            <confirmation-header-text
                    :text="headerText"
                    icon="mdi-file-document"/>
        </v-flex>
        <v-flex xs12 class="mt-2">
            <v-layout class="" row v-for="(d,index) in documents" wrap :key="d.name">
                <v-flex xs12>
                    <v-alert type="info"
                             outlined
                             :icon="false"
                             dense
                             class="mb-2">
                        <span style="color: #1566C0;">{{index+1}}. {{d.name}}</span>
                        <span v-if="d.required"
                              style="color: red; font-size: 12px; margin-left: 4px;">(Mandatory)</span><br>
                        <span v-if="d.description" style="color: black; font-size: 14px;margin-left: 14px;">({{d.description}})</span>
                    </v-alert>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-flex>

</template>

<script>
    import ConfirmationHeaderText from "../components/ConfirmationHeaderText";

    export default {
        name: "Documents",
        props: ['documents', 'headerText'],
        components: {ConfirmationHeaderText
        }
    }
</script>

